export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-900 to-background-800 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-6 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-3 tracking-tight">
                移动端下载
              </h2>
              <p className="text-foreground-300 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                今日看料App —— 随时随地，精彩不停。专为移动端优化的阅读体验，更快的加载速度，更便捷的操作方式。支持iOS和Android双平台，点击下方按钮即可下载。
              </p>

              <div className="grid grid-cols-2 gap-3 md:gap-4 max-w-sm mx-auto lg:mx-0 mb-6">
                {[
                  { icon: 'ri-notification-3-line', text: '实时推送不遗漏' },
                  { icon: 'ri-moon-line', text: '夜间模式护眼' },
                  { icon: 'ri-download-cloud-2-line', text: '离线阅读省流量' },
                  { icon: 'ri-bookmark-line', text: '收藏功能随心存' },
                ].map((f) => (
                  <div key={f.text} className="flex items-center gap-2 text-foreground-300 text-xs">
                    <i className={`${f.icon} text-primary-400 text-base`}></i>
                    <span>{f.text}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  iOS 下载
                </a>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/15 text-background-50 font-semibold text-sm border border-background-50/20 hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-fill text-lg"></i>
                  Android 下载
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-56 h-72 md:w-64 md:h-80 rounded-2xl overflow-hidden bg-background-700">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20UI%20mockup%20for%20news%20aggregation%20platform%20showing%20article%20cards%20with%20warm%20amber%20accents%20on%20dark%20background%2C%20clean%20minimal%20typography%2C%20editorial%20design%20layout%2C%20sleek%20smartphone%20screen%20mockup%20with%20content%20feed%2C%20premium%20app%20interface%20design&width=600&height=900&seq=app-mockup-screen&orientation=portrait"
                  alt="今日看料App界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}